import Immutable from 'seamless-immutable'

export default Immutable({
  active: 1,
  list: [{ id: 1, camera: 'main' }],
})



// WEBPACK FOOTER //
// ./src/store/scenes/scenes.model.js